<template>
  <div class="cart_button-mobile">
    <p v-if="!product.preorder && product.stock && !inCart">
      <a
        id="buy-in-one-click-mobile"
        class="kupit pum-trigger buy-one-click-product"
        style="cursor: pointer"
        @click.stop.prevent="onQuickOrder"
        v-if="!product.preorder && product.stock && !inCart"
      >
        {{ $t('buyOneClick') }}
      </a>
    </p>
    <p v-if="product.stock && !inCart && !product.preorder">
      <button
        type="button"
        name="add-to-cart-mobile"
        class="single_add_to_cart_button button alt"
        @click.stop.prevent="onAddToCart"
        v-if="product.stock && !inCart && !product.preorder"
      >
        {{ $t('addToCart') }}
      </button>
    </p>
    <router-link
      id="add-to-cart-button-mobile"
      to="/cart"
      class="kupit pum-trigger"
      :title="$t('showCart')"
      v-if="!product.preorder && product.stock && inCart"
    >
      {{ $t('showCart') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'CartButtonsMobile',
  props: {
    product: {
      type: Object,
      require: true,
      default: () => ({}),
    },
    onQuickOrder: Function,
    onAddToCart: Function,
    inCart: Boolean,
  },
}
</script>

<style>
.cart_button-mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  display: flex;
  padding: 6px 4px;
  justify-content: space-between;
  background: #fff;
}
.cart_button-mobile p {
  width: 49%;
  padding: 0;
}
.cart_button-mobile #buy-in-one-click-mobile {
  height: 50px;
}
.cart_button-mobile #buy-in-one-click-mobile,
.cart_button-mobile #add-to-cart-mobile {
  display: flex;
  align-items: center;
  border-radius: 10px;
}
.product-page #bwc-widget-action.bwc-mobile {
  bottom: 75px !important;
}
@media only screen and (max-width: 600px) {
  .product-page .netpeak {
    bottom: 62px;
  }
}
.product-page .static-button.back-to-top-button {
  bottom: 75px;
}
#add-to-cart-button-mobile {
  width: 100%;
  height: 50px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
</style>
